// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `alarmClock/index${i + 1}`,
  name: `alarmClockIndex${i + 1}`,
  component: () => import(`@/views/use/alarmClock/index${i + 1}.vue`)
}))



export default {
  path: '/use',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,

  ],
};
